export function VideochatFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 1.536-.405 2.97-1 4.23V21h-4.636c-1.32.64-2.801 1-4.364 1-5.523 0-10-4.477-10-10zm8.757-2.546a.5.5 0 00-.757.43v4.233a.5.5 0 00.757.429l3.528-2.117a.5.5 0 000-.858l-3.528-2.117z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
